import loaderIcon from "./icons/loader-animation.svg";
import { ILoaderComponent } from "types/gaiaComponents/loader";

export enum LoaderSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}

export enum LoaderType {
    Default = 'default',
    ReducedMotion = 'reduced-motion'
}


export const Loader = (props: ILoaderComponent) => {

    return (
        <div className={`ga-loader ga-loader__${props.type} ga-loader__${props.type}--${props.size}`} data-cy={props.dataCy} role={props.role} aria-hidden={props.ariaHidden}>
            <img
                src={loaderIcon}
                alt="Loader Animation"
                className="ga-loader__icon"
            />
            {props.text && <p className="ga-loader__text">{props.text}</p>}
        </div>
    );
};

Loader.displayName = "Loader";